export enum PDialogPosition {
  STANDARD = 'standard',
  END = 'right',
  BOTTOM = 'bottom',
  TOP = 'top',
}

export enum PFloatingPanelDialogVariant {
  TABS = 'tabs',
  STEPS = 'steps',
}

export type PFloatingDialogTab = {
  key: string
  label: string
}

export type PFloatingDialogStep = {
  key: string
  label: string
  icon: string
  description?: string
}
